<script setup>
import Placeholder from '../public/images/article-placeholder.png'

defineProps({
  article: {
    type: Object,
    required: true
  },
  target: {
    type: String,
    default: '_self'
  }
})

const { formatDate } = useHelpers()

</script>

<template>
  <NuxtLink
    :to="`/blog/${article.slug}`"
    :target="target"
    class="space-y-2 rounded-lg bg-light-card pb-4 font-montserrat text-logan shadow-md">
    <div>
      <NuxtImg
        :src="article.thumbnail ?? Placeholder"
        alt="thumbnail"
        fit="cover"
        loading="lazy"
        preload
        class="w-full rounded-t-lg sm:h-[200px] lg:h-[250px]" />
    </div>
    <div class="flex space-x-3 px-8 py-4">
      <BaseIcon
        name="calendar"
        class="size-5" />
      <span>{{ formatDate(article.published_at) }}</span>
    </div>
    <div class="my-4 space-y-3 px-8">
      <h3 class="font-bold uppercase leading-relaxed text-white sm:text-lg lg:text-xl">
        {{ article.title }}
      </h3>
      <p class="line-clamp-4 leading-relaxed">
        {{ article.description }}
      </p>
    </div>
    <div
      v-if="article.author"
      class="flex items-center space-x-4 px-8 py-4">
      <img
        v-if="article.author.avatar"
        :src="article.author.avatar"
        :alt="article.author.name"
        class="size-8 rounded-full shadow">
      <span class="text-white">{{ article.author.name }}</span>
    </div>
  </NuxtLink>
</template>

<style scoped lang="css">

</style>
